import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SearchService } from 'src/services/search-service.service';
import { Title } from '@angular/platform-browser';
import { AuthenticationService } from '@app/auth/authentication.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { zip, forkJoin } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-explore-island',
  templateUrl: './explore-island.component.html',
  styleUrls: ['./explore-island.component.scss'],
  providers: [MessageService],
})
export class ExploreIslandComponent implements OnInit {
  islandId: any = '';
  categoryId = '';
  activeIndex: any;
  islandsData: any[] = [];
  categoryData: any[] = [];
  facilitiesArr: any = [];
  roomFacilities: any = [];
  activitiesArr: any = [];
  AccreditationsArr: any = [];
  public selectedIslands: any = [];
  public selectedlandCategorys: any = [];
  public selectedFacilities: any = [];
  public refIslandList: any = [];
  public reflandCatType: any = [];
  public refamentsList: any = [];
  public isLandTypes: any = [];
  public islandCatTypes: any = [];
  public amentisTypes: any = [];
  island: any = null;
  category: any = null;
  activeTabIndex = -1;
  wishlistData: any = [];
  currentUser: any;
  whistlist: any;
  selcat = '';
  public pageNumber: number = 1;
  public pagePlacesNumber: number = 1;
  public pageFoodNumber: number = 1;
  placesToSeeData: any = [];
  thingsToDoData: any = [];
  whereToStayData: any = [];
  public language: any;
  public listingDetails: any = [];
  public productImageList: any = [];
  image = '';
  isViewThingsMoreRecords = false;
  isViewPlacesMoreRecords = false;
  isViewMoreRecords = false;
  totalRecords: any;
  totalPlacesRecords: any;
  totalFoodRecords: any;
  islandName = '';
  displayCustom: boolean;
  responsiveOptionsBanner = [
    {
      breakpoint: '1024px',
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: '768px',
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: '640px',
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: '480px',
      numVisible: 1,
      numScroll: 1,
    },
  ];

  constructor(
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private http: HttpClient,
    public searchService: SearchService,
    private authenticationService: AuthenticationService,
    private messageService: MessageService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    //this.getIslandsData();
    this.getCategoryData();
    this.language = localStorage.getItem('language');
    if (this.language == 'EN') {
      this.language = 'ENGLISH';
    }
    if (this.language == 'FR') {
      this.language = 'FRENCH';
    }
    if (this.language == 'DE') {
      this.language = 'GERMAN';
    }
    if (this.language == 'IT') {
      this.language = 'ITALIAN';
    }
    if (this.language == 'ES') {
      this.language = 'SPANISH';
    }
    if (this.language == 'RU') {
      this.language = 'RUSSIAN';
    }
    if (this.language == 'ZH') {
      this.language = 'CHINESE';
    }
    if (this.language == 'PT') {
      this.language = 'PORTUGUESE';
    }
    if (this.language == 'HI') {
      this.language = 'HINDI';
    }
    if (this.language == 'JA') {
      this.language = 'JAPANESE';
    }
    if (this.language == 'AR') {
      this.language = 'ARABIC';
    }
    zip(this.activatedRoute.paramMap, this.activatedRoute.queryParams).subscribe(([paramMap, params]) => {
      this.islandId = paramMap.get('islandId');
      this.categoryId = params.categoryId;
      this.getUpdatedDetaills().subscribe(() => {
        this.whereToStayModule();
        this.placesToSeeModule();
        this.foodModule();
        this.updateData();
      });
    });
  }

  imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }

  ViewThingsMoreRecord() {
    this.pageFoodNumber = this.pageFoodNumber + 1;
    this.foodModule();
  }

  ViewPlacesMoreRecord() {
    this.pagePlacesNumber = this.pagePlacesNumber + 1;
    this.placesToSeeModule();
  }

  ViewMoreRecord() {
    this.pageNumber = this.pageNumber + 1;
    this.whereToStayModule();
  }

  getUpdatedDetaills() {
    return this.searchService.getViewListingDetails(this.islandId).pipe(
      tap((data: any) => {
        this.listingDetails = [];
        this.listingDetails = data;
        this.islandName = this.listingDetails.productName.replace(/island/gi, '').trim();
        var language = localStorage.getItem('language');
        if (
          this.listingDetails.productDescriptionMv &&
          this.listingDetails.productDescriptionMv !== '' &&
          language !== 'EN'
        ) {
          this.listingDetails.productDescription = this.listingDetails.productDescriptionMv.replace(/\\n/g, '<br>');
        }
        this.listingDetails.productTypes.forEach((item: any) => {
          if (item.productTypeDescriptionMv && item.productTypeDescriptionMv !== '' && language !== 'EN') {
            item.productTypeDescription = item.productTypeDescriptionMv.replace('&amp;', '&');
          } else {
            item.productTypeDescription = item.productTypeDescription.replace('&amp;', '&');
          }
        });
        this.titleService.setTitle(this.listingDetails.productName + ' ' + '| The Seychelles Islands');
        if (this.listingDetails && this.listingDetails.multimedia) {
          this.listingDetails.multimedia = this.listingDetails.multimedia.filter(
            (test: any, index: any, array: any) =>
              index === array.findIndex((findTest: any) => findTest.multimediaId === test.multimediaId)
          );
          this.productImageList = this.listingDetails.multimedia.filter(
            (product: any) => product.attributeIdMultimediaContent == 'IMAGE'
          );
          if (this.productImageList.length > 0) {
            this.image = this.productImageList[0].serverPath;
            const width = window.innerWidth;
            const height = window.innerHeight;
            this.productImageList.forEach((item: any) => {
              const img = item.serverPath.split('&');
              item['plainPath'] = item.serverPath.split('?')[0] + '?w=' + width + '&h=' + height;
              item['serverPathWithCrop'] = item.serverPath;
            });
          }
        }
        let catType = 'Island';
        if (this.listingDetails.productCategoryId !== 'DESTINFO') {
          catType = this.listingDetails.productCategoryDescription;
        }
        let browserUrl = 'https://www.seychelles.com/home';
        this.image = 'https://www.seychelles.com/assets/images/favicons/favicon-192x192.png';
        if (location.href.indexOf('localhost') >= 0 || location.href.indexOf('staging') >= 0) {
          browserUrl = 'https://staging.seychelles.com/home';
          this.image = 'https://staging.seychelles.com/assets/images/favicons/favicon-192x192.png';
        }
      })
    );
  }

  // getIslandsData() {
  //   this.http
  //     .get<any>('../assets/json/islands-data.json')
  //     .toPromise()
  //     .then((res) => {
  //       this.islandsData = res.data;
  //       this.updateData();
  //     })
  //     .catch((e) => console.error(e));
  // }

  getCategoryData() {
    this.http
      .get<any>('../assets/json/category-data.json')
      .toPromise()
      .then((res) => {
        this.categoryData = res.data;
        this.updateData();
      })
      .catch((e) => console.error(e));
  }

  updateData() {
    // if (this.islandId && this.islandsData.length) {
    //   this.island = this.islandsData.find((item) => item.id === this.islandId);
    // }
    if (this.categoryData.length) {
      this.category = this.categoryData.find((item) => item.id === this.categoryId);
      this.activeTabIndex = this.categoryData.findIndex((item) => item.id === this.categoryId);
      if (this.activeTabIndex === -1) {
        this.activeTabIndex = 0;
        this.category = this.categoryData[0];
      }
    }
  }

  sstlText(item: any, accr: any) {
    const sustainabilityMap = {
      ssblue: 'Blue',
      ssgold: 'Gold',
      sssliver: 'Silver',
      sssilver: 'Silver',
      ssbronze: 'Bronze',
    };
    let val = 'Blue';
    for (const [code, value] of Object.entries(sustainabilityMap)) {
      if (accr.includes(code)) {
        val = value;
      }
    }

    // If any matching accreditation was found, return formatted HTML
    if (val) {
      const html = `<div style='color:#399;font-weight:bold;'>Sustainable Seychelles - ${val} Recognition</div>`;
      const htmlr =
        '<div>This Sustainable Seychelles rating is provided to Seychelles.com by the Seychelles Tourism Department, and is usually determined by a committee and adherence to set criteria.</div>';

      return html + htmlr;
    }

    return '';
  }

  isSustainableSeychelles(accr: string): boolean {
    const sustainableTypes = ['ssblue', 'ssgold', 'sssliver', 'ssbronze', 'sssilver'];
    return sustainableTypes.some((type) => accr.includes(type));
  }
  whereToStayModule() {
    this.searchService
      .planYourVisitSearchListing(
        'ACCOMM',
        null,
        null,
        this.islandName.charAt(0).toUpperCase() + this.islandName.slice(1),
        null,
        this.pageNumber
      )
      .subscribe((dataw) => {
        Array.from(dataw.products).map(async (mData: any) => {
          await this.searchService.getViewListingDetailsEn(mData.productId).subscribe((data: any) => {
            mData.productName = data.productName;
            mData.createdAt = data.createdDate;
            if (data.frequencyStartDate && data.frequencyStartDate != '') {
              const sDate = new Date(data.frequencyStartDate);
              const startDate = sDate.getDate();
              const startRm = ['st', 'nd', 'rd'][(startDate % 10) - 1] || 'th';
              mData['startDate'] = sDate;
              mData['startRm'] = startRm;

              if (data.frequencyStartDate == data.frequencyEndDate) {
                mData['endDate'] = 'none';
              } else {
                const eDate = new Date(data.frequencyEndDate);
                const endDate = eDate.getDate();
                const endRm = ['st', 'nd', 'rd'][(endDate % 10) - 1] || 'th';
                mData['endDate'] = eDate;
                mData['endRm'] = endRm;
              }
            } else {
              mData['startDate'] = 'none';
            }
            mData['showItem'] = true;
            if (data.attributes) {
              mData.accredations = [];
              Array.from(data.attributes).map((attData: any) => {
                if (attData.attributeTypeId == 'ACCREDITN' && attData.attributeId !== 'UAA') {
                  const newItem = 'ACCREDITN' + attData.attributeId.trim().toUpperCase(); // Trim and convert to uppercase
                  this.AccreditationsArr.push({
                    code: newItem,
                    name: newItem,
                    description: attData.attributeIdDescription,
                  });
                  this.AccreditationsArr = Array.from(
                    new Set(this.AccreditationsArr.map((item: any) => item.description))
                  ).map((description) => {
                    return this.AccreditationsArr.find((item: any) => item.description === description);
                  });
                }
                if (attData.attributeId === 'Deals&Offers') {
                  if (this.refamentsList !== 'TAGDeals-Offers') {
                    mData.showItem = false;
                  }
                }
                if (attData.attributeTypeId === 'ACCREDITN') {
                  mData.accrdIn = 'true';
                }
                if (
                  attData.attributeTypeId === 'ACCREDITN' &&
                  (attData.attributeId === 'SSTL' || attData.attributeId === 'SSC')
                ) {
                  mData.accredations.push('../../../assets/images/ssblue.png');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'SSBRONZE') {
                  mData.accredations.push('../../../assets/images/ssbronze.png');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'SSGOLD') {
                  mData.accredations.push('../../../assets/images/ssgold.png');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'SSSLIVER') {
                  mData.accredations.push('../../../assets/images/sssilver.png');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'SSSILVER') {
                  mData.accredations.push('../../../assets/images/sssilver.png');
                }
                // if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'UAA') {
                // data.accredations.push('../../../assets/images/home-slick-slider-3.jpg');
                // }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'TSCL') {
                  mData.accredations.push('../../../assets/images/safe-label.jpg');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'WORKCATION') {
                  mData.accredations.push('../../../assets/images/workcation.jpg');
                }
                if (attData.attributeTypeId === 'STARRATING' && attData.attributeIdDescription == 'Ungraded') {
                  data.starRating = -1;
                }
                if (attData.attributeTypeId === 'STARRATING' && attData.attributeIdDescription == 'Ungraded') {
                  mData.starRating = -1;
                  // if (this.sortValue && this.selectedCategorieName == 'ACCOMM') {
                  //   this.sort(this.sortValue);
                  // }
                }
              });
            }
            if (data.productTypes) {
              mData.classification = [];
              var language = localStorage.getItem('language');
              Array.from(data.productTypes).map((attData: any) => {
                if (attData.productTypeDescriptionMv && attData.productTypeDescriptionMv !== '' && language !== 'EN') {
                  attData.productTypeDescription = attData.productTypeDescriptionMv.replace('&amp;', '&');
                } else {
                  attData.productTypeDescription = attData.productTypeDescription.replace('&amp;', '&');
                }
                mData.classification.push(attData.productTypeDescription);
              });
            }
          });
          if (mData.productImage) {
            let img = mData.productImage.split('&');
            img[1] = 'fit=crop&w=400';
            img[2] = 'h=600';
            mData.productImage = img.join('&');
          }
        });

        this.whereToStayData = [...this.whereToStayData, ...dataw.products];
        this.totalRecords = dataw.numberOfResults;
        let noOfPages = this.totalRecords / 12;
        if (noOfPages) {
          if (this.pageNumber <= noOfPages) this.isViewMoreRecords = true;
          else this.isViewMoreRecords = false;
        } else {
          this.isViewMoreRecords = false;
        }
      });
  }

  placesToSeeModule() {
    this.searchService
      .planYourVisitSearchListing(
        'ATTRACTION',
        null,
        null,
        this.islandName.charAt(0).toUpperCase() + this.islandName.slice(1),
        null,
        this.pagePlacesNumber
      )
      .subscribe((dataw) => {
        Array.from(dataw.products).map(async (mData: any) => {
          await this.searchService.getViewListingDetailsEn(mData.productId).subscribe((data: any) => {
            mData.productName = data.productName;
            mData.createdAt = data.createdDate;
            if (data.frequencyStartDate && data.frequencyStartDate != '') {
              const sDate = new Date(data.frequencyStartDate);
              const startDate = sDate.getDate();
              const startRm = ['st', 'nd', 'rd'][(startDate % 10) - 1] || 'th';
              mData['startDate'] = sDate;
              mData['startRm'] = startRm;

              if (data.frequencyStartDate == data.frequencyEndDate) {
                mData['endDate'] = 'none';
              } else {
                const eDate = new Date(data.frequencyEndDate);
                const endDate = eDate.getDate();
                const endRm = ['st', 'nd', 'rd'][(endDate % 10) - 1] || 'th';
                mData['endDate'] = eDate;
                mData['endRm'] = endRm;
              }
            } else {
              mData['startDate'] = 'none';
            }
            mData['showItem'] = true;
            if (data.attributes) {
              mData.accredations = [];
              Array.from(data.attributes).map((attData: any) => {
                if (attData.attributeTypeId == 'ACCREDITN' && attData.attributeId !== 'UAA') {
                  const newItem = 'ACCREDITN' + attData.attributeId.trim().toUpperCase(); // Trim and convert to uppercase
                  this.AccreditationsArr.push({
                    code: newItem,
                    name: newItem,
                    description: attData.attributeIdDescription,
                  });
                  this.AccreditationsArr = Array.from(
                    new Set(this.AccreditationsArr.map((item: any) => item.description))
                  ).map((description) => {
                    return this.AccreditationsArr.find((item: any) => item.description === description);
                  });
                }
                if (attData.attributeId === 'Deals&Offers') {
                  if (this.refamentsList !== 'TAGDeals-Offers') {
                    mData.showItem = false;
                  }
                }
                if (attData.attributeTypeId === 'ACCREDITN') {
                  mData.accrdIn = 'true';
                }
                if (
                  attData.attributeTypeId === 'ACCREDITN' &&
                  (attData.attributeId === 'SSTL' || attData.attributeId === 'SSC')
                ) {
                  mData.accredations.push('../../../assets/images/ssblue.png');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'SSBRONZE') {
                  mData.accredations.push('../../../assets/images/ssbronze.png');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'SSGOLD') {
                  mData.accredations.push('../../../assets/images/ssgold.png');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'SSSLIVER') {
                  mData.accredations.push('../../../assets/images/sssilver.png');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'SSSILVER') {
                  mData.accredations.push('../../../assets/images/sssilver.png');
                }
                // if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'UAA') {
                // data.accredations.push('../../../assets/images/home-slick-slider-3.jpg');
                // }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'TSCL') {
                  mData.accredations.push('../../../assets/images/safe-label.jpg');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'WORKCATION') {
                  mData.accredations.push('../../../assets/images/workcation.jpg');
                }
                if (attData.attributeTypeId === 'STARRATING' && attData.attributeIdDescription == 'Ungraded') {
                  data.starRating = -1;
                }
                if (attData.attributeTypeId === 'STARRATING' && attData.attributeIdDescription == 'Ungraded') {
                  mData.starRating = -1;
                  // if (this.sortValue && this.selectedCategorieName == 'ACCOMM') {
                  //   this.sort(this.sortValue);
                  // }
                }
              });
            }
            if (data.productTypes) {
              mData.classification = [];
              var language = localStorage.getItem('language');
              Array.from(data.productTypes).map((attData: any) => {
                if (attData.productTypeDescriptionMv && attData.productTypeDescriptionMv !== '' && language !== 'EN') {
                  attData.productTypeDescription = attData.productTypeDescriptionMv.replace('&amp;', '&');
                } else {
                  attData.productTypeDescription = attData.productTypeDescription.replace('&amp;', '&');
                }
                mData.classification.push(attData.productTypeDescription);
              });
            }
          });
          if (mData.productImage) {
            let img = mData.productImage.split('&');
            img[1] = 'fit=crop&w=400';
            img[2] = 'h=600';
            mData.productImage = img.join('&');
          }
        });
        this.placesToSeeData = [...this.placesToSeeData, ...dataw.products];
        this.totalPlacesRecords = dataw.numberOfResults;
        let noOfPages = this.totalPlacesRecords / 12;
        if (noOfPages) {
          if (this.pagePlacesNumber <= noOfPages) this.isViewPlacesMoreRecords = true;
          else this.isViewPlacesMoreRecords = false;
        } else {
          this.isViewPlacesMoreRecords = false;
        }
      });
  }

  foodModule() {
    this.searchService
      .planYourVisitSearchListing(
        'RESTAURANT',
        null,
        null,
        this.islandName.charAt(0).toUpperCase() + this.islandName.slice(1),
        null,
        this.pageFoodNumber
      )
      .subscribe((dataw) => {
        Array.from(dataw.products).map(async (mData: any) => {
          await this.searchService.getViewListingDetailsEn(mData.productId).subscribe((data: any) => {
            mData.productName = data.productName;
            mData.createdAt = data.createdDate;
            if (data.frequencyStartDate && data.frequencyStartDate != '') {
              const sDate = new Date(data.frequencyStartDate);
              const startDate = sDate.getDate();
              const startRm = ['st', 'nd', 'rd'][(startDate % 10) - 1] || 'th';
              mData['startDate'] = sDate;
              mData['startRm'] = startRm;

              if (data.frequencyStartDate == data.frequencyEndDate) {
                mData['endDate'] = 'none';
              } else {
                const eDate = new Date(data.frequencyEndDate);
                const endDate = eDate.getDate();
                const endRm = ['st', 'nd', 'rd'][(endDate % 10) - 1] || 'th';
                mData['endDate'] = eDate;
                mData['endRm'] = endRm;
              }
            } else {
              mData['startDate'] = 'none';
            }
            mData['showItem'] = true;
            if (data.attributes) {
              mData.accredations = [];
              Array.from(data.attributes).map((attData: any) => {
                if (attData.attributeTypeId == 'ACCREDITN' && attData.attributeId !== 'UAA') {
                  const newItem = 'ACCREDITN' + attData.attributeId.trim().toUpperCase(); // Trim and convert to uppercase
                  this.AccreditationsArr.push({
                    code: newItem,
                    name: newItem,
                    description: attData.attributeIdDescription,
                  });
                  this.AccreditationsArr = Array.from(
                    new Set(this.AccreditationsArr.map((item: any) => item.description))
                  ).map((description) => {
                    return this.AccreditationsArr.find((item: any) => item.description === description);
                  });
                }
                if (attData.attributeId === 'Deals&Offers') {
                  if (this.refamentsList !== 'TAGDeals-Offers') {
                    mData.showItem = false;
                  }
                }
                if (attData.attributeTypeId === 'ACCREDITN') {
                  mData.accrdIn = 'true';
                }
                if (
                  attData.attributeTypeId === 'ACCREDITN' &&
                  (attData.attributeId === 'SSTL' || attData.attributeId === 'SSC')
                ) {
                  mData.accredations.push('../../../assets/images/ssblue.png');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'SSBRONZE') {
                  mData.accredations.push('../../../assets/images/ssbronze.png');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'SSGOLD') {
                  mData.accredations.push('../../../assets/images/ssgold.png');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'SSSLIVER') {
                  mData.accredations.push('../../../assets/images/sssilver.png');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'SSSILVER') {
                  mData.accredations.push('../../../assets/images/sssilver.png');
                }
                // if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'UAA') {
                // data.accredations.push('../../../assets/images/home-slick-slider-3.jpg');
                // }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'TSCL') {
                  mData.accredations.push('../../../assets/images/safe-label.jpg');
                }
                if (attData.attributeTypeId === 'ACCREDITN' && attData.attributeId === 'WORKCATION') {
                  mData.accredations.push('../../../assets/images/workcation.jpg');
                }
                if (attData.attributeTypeId === 'STARRATING' && attData.attributeIdDescription == 'Ungraded') {
                  data.starRating = -1;
                }
                if (attData.attributeTypeId === 'STARRATING' && attData.attributeIdDescription == 'Ungraded') {
                  mData.starRating = -1;
                  // if (this.sortValue && this.selectedCategorieName == 'ACCOMM') {
                  //   this.sort(this.sortValue);
                  // }
                }
              });
            }
            if (data.productTypes) {
              mData.classification = [];
              var language = localStorage.getItem('language');
              Array.from(data.productTypes).map((attData: any) => {
                if (attData.productTypeDescriptionMv && attData.productTypeDescriptionMv !== '' && language !== 'EN') {
                  attData.productTypeDescription = attData.productTypeDescriptionMv.replace('&amp;', '&');
                } else {
                  attData.productTypeDescription = attData.productTypeDescription.replace('&amp;', '&');
                }
                mData.classification.push(attData.productTypeDescription);
              });
            }
          });
          if (mData.productImage) {
            let img = mData.productImage.split('&');
            img[1] = 'fit=crop&w=400';
            img[2] = 'h=600';
            mData.productImage = img.join('&');
          }
        });
        this.thingsToDoData = [...this.thingsToDoData, ...dataw.products];
        this.totalFoodRecords = dataw.numberOfResults;
        let noOfPages = this.totalFoodRecords / 12;
        if (noOfPages) {
          if (this.pageFoodNumber <= noOfPages) this.isViewThingsMoreRecords = true;
          else this.isViewThingsMoreRecords = false;
        } else {
          this.isViewThingsMoreRecords = false;
        }
      });
  }

  addToWhishList(item: any) {
    this.currentUser = this.authenticationService.currentUserValue;
    if (this.currentUser) {
      const prodcut = this.wishlistData.find((product: any) => product.field_product_id === item.productId);
      if (prodcut) {
        const wishlist = this.wishlistData.find((product: any) => product.field_product_id === item.productId);
        if (wishlist) {
          this.searchService.removeWishListDeatils(wishlist.nid).subscribe(
            (data) => {
              // this.whistlist = this.whistlist.filter((product: any) => product.productId !== item.productId);
              item.color = '#bbbbbb';
              this.messageService.add({
                key: 'add-wishlist',
                severity: 'success',
                summary: this.translate.instant('Success'),
                detail: this.translate.instant('Wishlist-Remove-Successfull'),
              });
              this.wishListDeatils();
            },
            (err) => {
              this.messageService.add({ severity: 'error', summary: err.message, detail: '' });
            }
          );
        }
      } else {
        this.wishListDeatils();
        if (this.wishlistData.length >= 10) {
          this.messageService.add({
            key: 'add-wishlist',
            severity: 'info',
            summary: 'Info',
            detail: this.translate.instant('WhishList-Exceed-Message'),
          });
        } else {
          this.searchService.postWishList(item.productId, this.selcat, item.classification).subscribe((result: any) => {
            if (result) {
              //item.color = '#00a7a6';
              item.color = '#e94363';
              this.messageService.add({
                key: 'add-wishlist',
                severity: 'success',
                summary: this.translate.instant('Success'),
                detail: this.translate.instant('Wishlist-Add-Successfull'),
              });
              this.wishListDeatils();
            }
          });
        }
      }
    } else {
      this.messageService.add({
        key: 'add-wishlist',
        severity: 'info',
        summary: 'Info',
        detail: this.translate.instant('WhishList-Login-Alert'),
      });
    }
  }

  wishListDeatils() {
    this.searchService.getWishList().subscribe((wishlistData) => {
      const productItem = wishlistData.map((productId: any) => `"${productId.field_product_id}"`).join(',');
      this.wishlistData = wishlistData;
      if (productItem !== '') {
        this.searchService.wishListDeatils(productItem).subscribe((data) => {
          this.whistlist = data.products;
          // this.searchService.getWishList().subscribe((wishlistData) => {
          //   this.wishlistData=[];
          //   this.wishlistData = wishlistData;
          //   console.log("wish",this.wishlistData)
        });
      }
    });
  }
}
